// extracted by mini-css-extract-plugin
export default {"footnote":"FootnoteSlice_footnote__NnRrt"};